import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components/confirm-dismiss-dialog/confirm-dismiss-dialog.component';
import { DataService, HelperService, HTTPService } from 'app/services';
import { DialogService } from 'primeng/dynamicdialog';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subscription } from 'rxjs';
import { round, find } from 'lodash';

@Component({
  selector: 'app-parts-lookup-dialog',
  templateUrl: './parts-lookup-dialog.component.html',
  styleUrls: ['./parts-lookup-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService],
})
export class PartsLookupDialogComponent implements OnInit {
  
  constructor(
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    public dialogService: DialogService,
    private helperService: HelperService,
  ) {
    const dialogData = this.dynamicDialogConfig.data;
    
  }

  ngOnInit() {}

  handleClose(isSuccess: boolean = false) {
    this.dynamicDialogRef.close({ isSuccess });
  }

  redirectToPartsTechConnection() {
    this.handleClose();
    this.helperService.openPageInNewExistingTab('/settings/integrations/parts-ordering', '');
  }


}
